export default __webpack_public_path__ + "static/media/rockeb.256185a7.ttf";